import React, { useEffect } from 'react';
import './App.css';
import { ChakraProvider, theme } from '@chakra-ui/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {
  ForgotPasswordPage,
  Layout,
  NoPage,
  ResetPasswordPage,
  SigninPage,
  SignupPage,
  VerifyEmailPage,
  TestMenu,
  ResourceCenter,
  UploadPrescription,
  DownloadReport,
} from './pages';
import { Loader } from './components';
import { UserAuthContextProvider } from './context/UserAuthContext';
import PrivacyPage from './pages/Privacy';
import TermsPage from './pages/Terms';
import RefundPage from './pages/Refund';
import DeleteAccountPage from './pages/DeleteAccount';
import { Cart } from './pages/Cart';
import useStore from './store/store';
import { PackagePage } from './pages/PackagePage';
import { PackagesPage } from './pages/PackagesPage';
import { TestsPage } from './pages/TestsPage';
import { TestPage } from './pages/TestPage';
import { getUser } from './cookie/user';
import { LabsPage } from './pages/LabsPage';
import { HomePage } from './pages/HomePage';
import { LabPage } from './pages/LabPage';
import { SearchLabs } from './pages/SearchLabs';
import { CartProvider } from './context/cart';
import AboutPage from './pages/About';
import ProfilePage from './pages/ProfilePage';
import { OrdersPage } from './pages/OrdersPage';
import { TestOrderDetails } from './pages/TestOrderDetails';
import { ContactPage } from './pages/ContactPage';
import { HealthScoreDetails } from './pages/HealthScoreDetails';
import { PackageOrderDetails } from './pages/PackageOrderDetails';

function App() {
  const { setUser } = useStore();
  const [isAppLoading, setIsAppLoading] = React.useState(true);

  useEffect(() => {
    let user1 = getUser();
    setUser(user1);

    const timer = setTimeout(() => {
      setIsAppLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [setUser]);

  if (isAppLoading) {
    return (
      <ChakraProvider theme={theme}>
        <Loader />
      </ChakraProvider>
    );
  }

  return (
    <ChakraProvider theme={theme}>
      <UserAuthContextProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="/search" element={<SearchLabs />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/delete-account" element={<DeleteAccountPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contactus" element={<ContactPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/refund" element={<RefundPage />} />
                <Route path="/package" element={<PackagePage />} />
                <Route path="/packages" element={<PackagesPage />} />
                <Route path="/tests" element={<TestsPage />} />
                <Route path="/test" element={<TestPage />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/labs" element={<LabsPage />} />
                <Route path="/lab" element={<LabPage />} />
                <Route path="/test-menu" element={<TestMenu />} />
                <Route path="/resource-center" element={<ResourceCenter />} />
                <Route path="/upload-prescription" element={<UploadPrescription />} />
                <Route path="/download-report" element={<DownloadReport />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/profile/orders" element={<OrdersPage />} />
                <Route
                  path="/profile/orders/testorderdetails"
                  element={<TestOrderDetails />}
                />
                <Route
                  path="/profile/orders/packagesorderdetails"
                  element={<PackageOrderDetails />}
                />
                <Route
                  path="/profile/orders/orderdetails/healthscore"
                  element={<HealthScoreDetails />}
                />
                <Route path="/signin" element={<SigninPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/verify-email" element={<VerifyEmailPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
              </Route>

              <Route path="*" element={<NoPage />} />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </UserAuthContextProvider>
    </ChakraProvider>
  );
}

export default App;
